<template lang="pug">
  div.d-flex.justify-center.align-center.pa-6(style="height: 100%")
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    v-card(v-else outlined)
      v-card-text.pa-6
        div.h5.primary500--text.text-center(v-if="success") Unsubscribe email successful
        div.h5.danger500--text.text-center(v-else) Unsubscribe email unsuccessful
      v-card-actions.pa-6
        v-btn(color="info500" block dark depressed href="https://yezza.com") {{ $t('close') }}
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default {
  name: 'UnsubscribeEmail',
  components: { VueQrcode },
  data () {
    return {
      success: null,
      isFetching: true
    }
  },
  mounted () {
    this.unsubscribe()
  },
  methods: {
    unsubscribe () {
      let email = null
      let slug = null
      if (this.$route.query.email) {
        email = this.$route.query.email
      }
      if (this.$route.query.slug) {
        slug = this.$route.query.slug
      }
      if (email && slug) {
        this.$axios.get(`/connect/${slug}/customers/unsubscribe?email=${email}`)
          .then(() => {
            this.success = true
            this.isFetching = false
          })
          .error(() => {
            this.success = false
            this.isFetching = false
          })
      }
    }
  },
}
</script>